import { render } from "./ResponseStatic.vue?vue&type=template&id=6648818d"
import script from "./ResponseStatic.vue?vue&type=script&lang=js"
export * from "./ResponseStatic.vue?vue&type=script&lang=js"

import "./ResponseStatic.vue?vue&type=style&index=0&id=6648818d&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__